import Checkbox from "@app/components/checkbox";
import { FormControl } from "@app/components/form-control";
import { BookOption } from "@app/constants";
import { useFormikContext } from "formik";

interface TryListeningCheckboxProps {
  name: string;
}

function TryListeningCheckbox({ name }: TryListeningCheckboxProps) {
  const formik = useFormikContext<{ bookOption: string }>();

  const values = formik.values;

  const render = () => {
    switch (values.bookOption) {
      case BookOption.VIP.toString():
      case BookOption.PURCHASE.toString():
        return (
          <label htmlFor="">
            <div className="mt-3 flex">
              <FormControl name={name}>
                <Checkbox
                  label="Cho nghe thử"
                  labelClassName="text-sm text-[#83898C]"
                />
              </FormControl>
            </div>
          </label>
        );
      default:
        return "";
    }
  };

  return <>{render()}</>;
}

export default TryListeningCheckbox;
